import { render, staticRenderFns } from "./TemplatePlateComp.vue?vue&type=template&id=0152afd3"
import script from "./TemplatePlateComp.vue?vue&type=script&lang=js"
export * from "./TemplatePlateComp.vue?vue&type=script&lang=js"
import style0 from "./TemplatePlateComp.vue?vue&type=style&index=0&id=0152afd3&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports